import React from "react";
import { banks } from "../data/banks";
import s from "./PartnersBlock.module.css";
import img from "../data/images/PartnersBlock@2x.png";

export default function PartnersBlock({ onChangeValue, onBankSelect }) {
  const handleTubClick = (event) => {
    onChangeValue(event.target.value);
  };

  const handleIconClick = (partner) => (event) => {
    onBankSelect(partner);
  };

  return (
    <div
      className={`row flex-row-reverse justify-content-center flex-sm-column-reverse flex-lg-row-reverse ${s.partnersWrapper}`}
    >
      <img
        className={`col-sm-12 col-lg-5 ${s.img}`}
        src={img}
        alt="Icons of partners at private computer"
      />
      <div className={`col-sm-12 col-lg-6 ${s.partners}`}>
        <div
          className={`row justify-content-center align-items-center ${s.tubsWrapper}`}
        >
          <button
            className={s.tub}
            value="1"
            type="button"
            onClick={handleTubClick}
          />
          <button
            className={s.activeTub}
            value="0"
            type="button"
            onClick={handleTubClick}
          />
        </div>
        <div
          className={`row justify-content-center align-items-center flex-row-reverse ${s.titleWrapper}`}
        >
          <h2 className={s.title}>בחר/י את הבנק שלך </h2>
        </div>
        <div
          className={`row flex-row-reverse justify-content-center ${s.iconsOfPartnersWrapper}`}
        >
          {banks.map((partner) => (
            <a
              className={s.iconLink}
              key={partner.id}
              onClick={handleIconClick(partner)}
            >
              <img
                src={partner.logo}
                className={s.icon}
                alt={partner.name}
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
